import { CSSProperties } from 'react'

export const s = {
  root: {
    marginTop: 33,
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  } as CSSProperties,
  card: {
    display: 'flex',
  },
  column: {
    marginLeft: 16,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  } as CSSProperties,
  row: {
    display: 'flex',
    alignItems: 'center',
  } as CSSProperties,
  text: {
    marginLeft: 8,
    fontSize: 18,
  },
  icon: {
    marginLeft: 25,
  },
}
